import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react';
import { ForwardRefRenderFunction, forwardRef } from 'react';
import { FieldError } from 'react-hook-form';

interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  error?: FieldError;
  formControlProps?: FormControlProps;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { name, label, error, formControlProps, ...props },
  ref,
) => {
  return (
    <FormControl flex="1" {...formControlProps} isInvalid={Boolean(error)}>
      {label && (
        <FormLabel
          htmlFor={name}
          fontFamily="mono"
          fontSize="11px"
          letterSpacing="0.12em"
          textTransform="uppercase"
          color="text.faint"
          mb="8px"
        >
          {label}
        </FormLabel>
      )}

      <ChakraInput
        ref={ref}
        id={name}
        name={name}
        variant="unstyled"
        borderRadius="0"
        borderBottom="1px solid"
        borderColor="line.strong"
        bg="transparent"
        color="text.primary"
        h="44px"
        px="0"
        fontSize="16px"
        _placeholder={{ color: 'text.faint' }}
        _hover={{ borderColor: 'text.muted' }}
        _focus={{ borderColor: 'accent.500', boxShadow: 'none' }}
        {...props}
      />

      {error && (
        <FormErrorMessage fontSize="13px" color="accent.500">
          {error.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export const Input = forwardRef<HTMLInputElement, InputProps>(InputBase);
